import { defineMessages } from 'react-intl'

const messages = defineMessages({
  showLegendTooltip: {
    id: 'ContentChartFooter.showLegendTooltip',
    description: 'Texto para el tooltip de la leyenda',
    defaultMessage: 'Leyenda'
  },
  showByGenderTooltip: {
    id: 'ContentChartFooter.showByGenderTooltip',
    description: 'Texto para el tooltip del desglose por sexo',
    defaultMessage: 'Desglose por género'
  },
  showTableTooltip: {
    id: 'ContentChartFooter.showTableTooltip',
    description: 'Texto para el tooltip de la tabla',
    defaultMessage: 'Datos como tabla'
  },
  openModalTooltip: {
    id: 'ContentChartFooter.openModalTooltip',
    description: 'Texto para el tooltip del modal',
    defaultMessage: 'Seleccionar el rango de fechas'
  },
  exportChartTooltip: {
    id: 'ContentChartFooter.exportChartTooltip',
    description: 'Texto para el tooltip de exportar',
    defaultMessage: 'Exportar gráfico'
  },
  expandChartTooltip: {
    id: 'ContentChartFooter.expandChartTooltip',
    description: 'Texto para el tooltip de pantalla completa',
    defaultMessage: 'Pantalla completa'
  },
  indicatorDetail: {
    id: 'ContentChartFooter.indicatorDetail',
    description: 'Texto para el botón para acceder al detalle de indicador',
    defaultMessage: 'Detalle del indicador'
  },
  downloadPNG: {
    id: 'ContentChartFooter.downloadPNG',
    description: 'Texto para el botón de descargar en PNG',
    defaultMessage: 'Descargar en PNG'
  },
  downloadJPEG: {
    id: 'ContentChartFooter.downloadJPEG',
    description: 'Texto para el botón de descargar en JPEG',
    defaultMessage: 'Descargar en JPEG'
  },
  downloadPDF: {
    id: 'ContentChartFooter.downloadPDF',
    description: 'Texto para el botón de descargar en PDF',
    defaultMessage: 'Descargar en PDF'
  },
  downloadSVG: {
    id: 'ContentChartFooter.downloadSVG',
    description: 'Texto para el botón de descargar en SVG',
    defaultMessage: 'Descargar en SVG'
  },
  downloadCSV: {
    id: 'ContentChartFooter.downloadCSV',
    description: 'Texto para el botón de descargar en CSV',
    defaultMessage: 'Descargar en CSV'
  },
  female: {
    id: 'ContentChartFooter.female',
    description: 'Texto para mujeres',
    defaultMessage: 'Mujeres'
  },
  male: {
    id: 'ContentChartFooter.male',
    description: 'Texto para hombres',
    defaultMessage: 'Hombres'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/ContentChartFooter/messages.js